import { Routes } from "@angular/router";
import { PrivacyPolicy } from "./pages/public/privacy-policy/privacy-policy.component";
import { PaymentComponent } from "./pages/public/payment/payment.component";
import { PaymentCompletedComponent } from "./pages/public/payment-completed/payment-completed.component";
import { PromoCodeComponent } from "./pages/public/promo-code/promo-code.component";
import { GroupShareComponent } from "./pages/public/group-share-code/group-share-code.component";
import { PrivacyPolicyWhiteLabel } from "./pages/public/privacy-policy-whitelabel/privacy-policy-whitelabel.component";
import { PrivacyPolicyUsa } from "./pages/public/privacy-policy-usa/privacy-policy-usa.component";
import { TermsAndConditionsUsa } from "./pages/public/terms-and-conditions-usa/terms-and-conditions-usa.component";
import { IntercomComponent } from "./pages/public/intercom/intercom.component";
import { PrivacyPolicyAfriform } from "./pages/public/privacy-policy-afriform/privacy-policy-afriform.component";

export const AppRoutes: Routes = [
  {
    // admin/pgs
    path: "admin",
    children: [
      {
        path: "pgs", // pages
        loadChildren:
          () => import('./pages/admin/admin-pages/admin-pages.module').then(m => m.AdminPagesModule),
      },
    ],
  },
  {
    // admin/pgs
    path: "provider",
    children: [
      {
        path: "pgs", // pages
        loadChildren:
          () => import('./pages/provider/provider-pages/provider-pages.module').then(m => m.ProviderPagesModule),
      },
    ],
  },
  {
    path: "legal/privacy-policy",
    component: PrivacyPolicy,
  },
  {
    path: "legal/privacy-policy-whitelabel",
    component: PrivacyPolicyWhiteLabel,
  },
  {
    path: "legal/privacy-policy-afriform",
    component: PrivacyPolicyAfriform,
  },
  {
    path: "legal/privacy-policy-usa",
    component: PrivacyPolicyUsa,
  },
  {
    path: "legal/terms-and-conditions-usa",
    component: TermsAndConditionsUsa,
  },
  {
    path: "promo-code",
    component: PromoCodeComponent,
  },
  {
    path: "group-code",
    component: GroupShareComponent,
  },
  {
    path: "payment/initiate",
    component: PaymentComponent,
  },
  {
    path: "intercom",
    component: IntercomComponent,
  },
  {
    path: "payment/payment-completed",
    component: PaymentCompletedComponent,
  },
  {
    path: '**',
    redirectTo: "provider/pgs/login",
  }
];
